import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CompanyAddressPrompt } from '@/containers/sequences/company-address-prompt.component';
import { SequencesContainer } from '@/containers/sequences/sequences-container.component';
import { SequencesListSkeleton } from '@/containers/sequences/sequences-list-skeleton.component';
import { SequencingPage } from '@/containers/sequences/sequencing-page.component';
import { sequenceListSearchSchema } from '@/containers/sequences/sequence-list-filters.util';
import { useSequencingNavigation } from '@/containers/sequences/use-sequencing-navigation.hook';

export const Route = createFileRoute('/sequences/')({
  component: SequencesRoute,
  validateSearch: sequenceListSearchSchema,
});

function SequencesRoute() {
  const navigate = useNavigate();
  const onNavigate = useSequencingNavigation();
  const { q, status, owner, favorites } = Route.useSearch();
  return (
    <SequencingPage
      title='Sequences'
      prefetchSequences
      checking={<SequencesListSkeleton />}
    >
      <CompanyAddressPrompt />
      <SequencesContainer
        selectedId={null}
        onNavigate={onNavigate}
        initialFilters={{
          query: q ?? '',
          status: status ?? 'all',
          owner: owner ?? null,
          favoritesOnly: favorites ?? false,
        }}
        onFiltersChange={(filters) =>
          void navigate({
            to: '/sequences',
            search: {
              ...(filters.query ? { q: filters.query } : {}),
              ...(filters.status !== 'all' ? { status: filters.status } : {}),
              ...(filters.owner ? { owner: filters.owner } : {}),
              ...(filters.favoritesOnly ? { favorites: true } : {}),
            },
            replace: true,
          })
        }
        onSelectSequence={(id, tab) => {
          if (id)
            void navigate({
              to: '/sequences/$sequenceId',
              params: { sequenceId: id },
              search: tab ? { tab } : {},
            });
        }}
      />
    </SequencingPage>
  );
}
